export default {
  SET_TENANTS_LIST(state, data) {
    state.items = data;
  },

  SET_LOADING(state, value) {
    state.loading = value;
  }
};
